module.exports = __webpack_public_path__ + "media/img/img-about-3-1e9ce346.JPG";